const DEFAULT_API_URL = 'http://localhost:3003';
const DEFAULT_LP_URL = 'http://localhost:3000';

export const API_URL = import.meta.env.VITE_API_URL?.trim() || DEFAULT_API_URL;

export const API_V1_BASE_URL = `${API_URL}/api/v1`;

export const LP_URL = (
  import.meta.env.VITE_LP_URL?.trim() ||
  DEFAULT_LP_URL
).replace(/\/+$/, '');
